<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emArchBasicDataResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <!-- 2023.12.6 备品备件模块没有规划启用，暂时隐藏相关功能 -->
                            <!-- withCustomRowActions去掉，隐藏行内扩展功能按钮（设备关联备件），待备品备件模块规划上线后放开-->
                            <em-table :entity="modelName"
                                      ref="emTable"
                                      importEnabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      enable-over-check
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                                <template #left-header>
                                    <stock-task-print
                                            :selected-items="selectedRows"
                                            :tag-business-code="2"
                                            :tag-material-code="1"
                                            :request-param="dynamicRequestParam"
                                            @refresh="handleSuccess"
                                            @taskCreatedSuccess = "handleGoto"
                                    />
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-puzzle-piece"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="btn.em.print.device.code"
                                        @click="getPicture()">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-video"
                                        class="btn btn-outline-primary btn-sm"
                                        show-name custom-label="btn.em.scan.device.code"
                                        @click="openScanner = true">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-th-list"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="title.em.epi.inspectionWorkOrder.search"
                                        @click="gotoInspectionWorkOrder">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-bars"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="title.em.epi.inspection.abnormal.record.search"
                                        @click="gotoInspectionRecord">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-bars"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="title.em.repair.repairWorkOrder"
                                        @click="gotoRepairWorkOrder">
                                    </em-button>
                                    <em-button
                                        type="process"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="title.em.pma.routerCard.search"
                                        @click="gotoEmMaMaintenanceWo">
                                    </em-button>
                                    <em-button type="process"
                                               class="btn btn-outline-primary btn-sm"
                                               :disabled="actionDisabled('selectOne')"
                                               show-name custom-label="title.em.accident.routerCard.search"
                                               @click="gotoAccidentRecord">
                                    </em-button>
                                    <!-- 2023.12.6 备品备件模块没有规划启用，暂时v-show="false"隐藏下面2个按钮和相关功能，待备品备件模块上线后放开 -->
                                    <em-button
                                        type="gotoChild"
                                        class="btn btn-outline-primary btn-sm"
                                        custom-icon="fa fa-fw fa-lg fa-link"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="设备关联备件"
                                        @click="gotoSparePartsRecord">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        class="btn btn-outline-primary btn-sm"
                                        custom-icon="fa fa-copy"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="复制关联备件"
                                        @click="openCopySppDialog" v-show="false">
                                    </em-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-icon="fa fa-fw fa-lg fa-link"
                                                   custom-label="设备关联备件"
                                                   @click="popSpa(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <b-button-group>
                                            <em-button
                                                    type="edit" custom-icon="fa fa-fw fa-lg fa-link"
                                                    custom-label="epc code管理"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @success="handleSuccess"
                                                    @click="operateEpcCode(row)">
                                            </em-button>
                                        </b-button-group>
                                    </div>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <sub-entity-list ref="spaEntityList" sub-entity="emArchBdaRelSppBrs"
                         parent-field="brsIdBda"></sub-entity-list>

        <el-dialog title="复制设备关联备件绑定关系" :visible.sync="copySppDialogVisible" :close-on-click-modal='false'
                   append-to-body
                   @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" :inline="true" :rules="rules">
                <el-form-item label="当前备件绑定关系复制到设备编码" prop="spaCode">
                    <el-input v-model="createForm.spaCode" placeholder="设备编码"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="copySppDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="copySppRecords()">复制</el-button>
            </div>
        </el-dialog>

        <el-dialog title="打印二维码" width="20%" :visible.sync="dialogPrintVisible">
            <el-image id="qrPicture"
                      style="width: 100px; height: 100px"
                      :src="src"></el-image>
            <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogPrintVisible = false">取 消</el-button>
                  <el-button v-print="'#qrPicture'" type="primary">打 印</el-button>
              </span>
        </el-dialog>
        <el-dialog title="扫一扫" :center="true" :visible.sync="openScanner" append-to-body @close="closeScannerDialog"
                   :close-on-click-modal='false'>
            <qr-code-scanner ref="scanner" @getCodeData='getData'>
            </qr-code-scanner>
        </el-dialog>
        <epc-bind-dialog
                :visible.sync="showEpcDialog"
                :bind-id="currentBindId"
                @success="handleSuccess"
                :tag-business-code=2
        />
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-05-27 06:50:23

import emCommonListMixin from "@/mixin/em/common/list";
import subEntityList from "@/components/em/EmModal/SubEntityList";
import emApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EpcBindDialog from "@/components/em/EmEpc/EmBindEpcComponent.vue";
import StockTaskPrint from "@/components/em/EmEpc/StocktakeTaskAndPrint.vue";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import {trim} from "lodash";


export default {
    name: "emArchBasicDataListView",
    mixins: [emCommonListMixin, emCustomVuexMixin,emApiMixin, emTableCheckedMixin, emCommonGotoMixin],
    components: {StockTaskPrint, EpcBindDialog, subEntityList, qrCodeScanner,},
    data() {
        return {
            showEpcDialog: false,
            currentBindId: 0,
            copySppDialogVisible: false,
            createForm: {
                brsIdBda: '',
                spaCode: ''
            },
            rules: {
                spaCode: [{required: true, message: '请输入要复制的设备编码'}]
            },
            dialogPrintVisible: false,
            openScanner: false,
            src: '',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectedRows() {
             return this.selectedItems;
        },
        dynamicRequestParam() {
            let requestParam = []
            for (let i = 0; i < this.selectedItems.length; i++) {
                requestParam.push({
                    "arcTypeLevelOne": trim(this.selectedItems[i].equipmentCategoryName),
                    "arcName": trim(this.selectedItems[i].name),
                    "arcCode": trim(this.selectedItems[i].code),
                    "arcSize": trim(this.selectedItems[i].bdaModel),
                    "expectedBin": trim(this.selectedItems[i].locationCode),
                    "expectedQuantity": '1',
                    "epcCode": trim(this.selectedItems[i].epcCode)
                })
            }
            return requestParam;
        },
    },
    methods: {
        popSpa(row) {
            this.$refs.spaEntityList.showModal(row.id);
        },
        operateEpcCode(row) {
            this.currentBindId = row.id;
            this.showEpcDialog = true;
        },
        handleSuccess() {
            this.$refs.emListFilter.doQuery();
        },
        handleGoto(response) {
            this.$_emGotoMixin_gotoHolderList("emStocktakingTask"
                    , {taskCodeFilter: response}
                    , {taskCode: response}
                    , false, {})
        },
        openCopySppDialog() {
            this.copySppDialogVisible = true;
        },
        getPicture() {
            let row = this.$store.state[this.modelName].entity;
            let _url = `${this.$_emApiMixin_entityBaseApi("emArchBasicData")}/getUrl`;
            this.$_emApiMixin_post(_url, row).then((data) => {
                this.src = data.data;
                this.dialogPrintVisible = true;
            });
        },
        getData(data) {
            console.log("get qr code data:" + data);
            this.openScanner = false;
            let self = this;
            //检验二维码的数据格式
            let id = data;
            try {
                console.log(id);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', id);
            this.$refs["emListFilter"].doQuery();
        },
        closeScannerDialog() {
            this.$refs.scanner.closeCamera();
            this.$refs.scanner.resetOutputData();
            this.openScanner = false;
        },
        gotoInspectionWorkOrder() {
            console.log(this.checkedRows[0].code)
            this.$_emGotoMixin_gotoHolderList('inspectionWorkOrder'
                , {bdaCodeFilter: this.checkedRows[0].code}, {}, false, {pathType: "list"}
                , 'workflow/find-by-query-form'
                // , {prdResultId: this.selectIds}, false, {
                //   customVuexName: this.customVuexName,
                //   prdResultId: this.selectIds }
            );
        },
        gotoInspectionRecord() {
            console.log(this.checkedRows[0].code)
            this.$_emGotoMixin_gotoHolderList('inspectionRecord'
                , {emArchBasicDataCodeFilter: this.checkedRows[0].code}, {}, false, {pathType: "list"}
                , 'workflow/find-by-query-form'
                // , {prdResultId: this.selectIds}, false, {
                //   customVuexName: this.customVuexName,
                //   prdResultId: this.selectIds }
            );
        },
        gotoRepairWorkOrder() {
            console.log(this.checkedRows[0].code)
            this.$_emGotoMixin_gotoHolderList('repairWorkOrder'
                , {rwoCodeBdaFilter: this.checkedRows[0].code}, {}, false, {pathType: "list"}
                , 'workflow/find-by-query-form'
                // , {prdResultId: this.selectIds}, false, {
                //   customVuexName: this.customVuexName,
                //   prdResultId: this.selectIds }
            );
        },
        gotoEmMaMaintenanceWo() {
            //console.log(this.checkedRows[0].code)
            this.$_emGotoMixin_gotoHolderList('emMaMaintenanceWo'
                , {emArchBasicDataCodeFilter: this.checkedRows[0].code}, {}, false, {pathType: "list"}
                , 'workflow/find-by-query-form'
                // , {prdResultId: this.selectIds}, false, {
                //   customVuexName: this.customVuexName,
                //   prdResultId: this.selectIds }
            );
        },
        gotoAccidentRecord() {
            //console.log(this.checkedRows[0].id)
            this.$_emGotoMixin_gotoHolderList('emAcctHandleRecordAhr'
                , {acctIdBdaFilter: this.checkedRows[0].id}, {}, false, {pathType: "list"}
            );
        },
        gotoSparePartsRecord() {
            this.$_emGotoMixin_gotoHolderList('emSparePartsInventorySpi'
                , {spiUsedDeviceFilter: this.checkedRows[0].id}, {}, false, {pathType: "list"}
            );
        },
        popSpaBarButton() {
            this.$refs.spaEntityList.showModal(this.checkedRows[0].id);
        },
        clearCreateForm() {
            this.createForm.brsIdBda = '';
            this.createForm.spaCode = '';
            this.$refs["createForm"].resetFields();
        },
        copySppRecords() {
            let self = this;
            self.$refs["createForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("emArchBdaRelSppBrs")}/copySppRecords`;
                    // console.log("复制备件的提交地址：")
                    // console.log(url)

                    this.createForm.brsIdBda = this.checkedRows[0].id; //绑定选定行的设备ID，传参，把备件列表从这个ID的设备复制给录入的编码的设备

                    //console.log(this.createForm)

                    self.$_emApiMixin_post(url, self.createForm)
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "复制成功",
                                    type: "success",
                                });
                                self.$refs["emListFilter"].doQuery()
                            } else {
                                self.$message({
                                    message: "复制失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.copySppDialogVisible = false;
                    })

                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },
    }
};
</script>
